import { useRef } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useQuery } from 'shared/helpers/RoutingHelpers';
import { InstantTransferSettleDialogContent } from 'shared/modules/superpay/instant-transfer-settle/InstantTransferSettleDialogContent';
import { CarrierWebviewHeader } from '../CarrierWebviewHeader';
import { useInstantTransferSettleInformation } from 'shared/modules/superpay/SuperPayAPI';
import { useDocumentTitle } from 'shared/layout/DocumentTitle';

export function InstantTransferSettleWebViewDialog() {
  const [{ load_id: loadID, load_guid: loadGUID }] = useQuery();
  const isEnabled = !!(loadGUID || loadID);

  const didNotifyNative = useRef(false);

  const { data: settleInformation, isLoading } =
    useInstantTransferSettleInformation(
      { loadGUID, loadID },
      {
        enabled: isEnabled,
        refetchOnWindowFocus: false,
      },
    );

  useDocumentTitle('Settle Instant Transfer Advance');

  if (isLoading) {
    return null;
  }

  return (
    <CarrierWebviewHeader>
      <InstantTransferSettleDialogContent
        settleInformation={settleInformation}
        onSuccess={() => {
          didNotifyNative.current = true;
          MobileAppBridge.successAndClose('Payment submitted successfully.');
        }}
        onClose={() => {
          if (!didNotifyNative.current) {
            MobileAppBridge.closeScreen();
          }
        }}
      />
    </CarrierWebviewHeader>
  );
}
